// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"lR-z","smallCardRow":"mR-z","largeCardRow":"nR-z","productSearchRow":"oR-z","curatedRow":"pR-z"};